import React from 'react';

import ExpandableFactbox from '@spp/ui-factbox';
import { config } from '../../config';

// eslint-disable-next-line react/prop-types
const Factbox = ({ title, components, i18n, ...rest }) => (
    <ExpandableFactbox
        title={title}
        expandBy={config.factbox.expandBy}
        i18n={config.factbox.i18n}
        {...rest}
    />
);

export default Factbox;



/** WEBPACK FOOTER **
 ** ./src/local-components/article/Factbox.js
 **/